/**
 * Go To Meetup 2023 формы
 */

import Cookies from 'js-cookie';

class ApplicationForm {

    constructor(form, settings, formLoader) {
        this.formTemplate = form.cloneNode(true);
        this.settings = settings;
        this.utms = {};
        this.offline = 0;
        this.form = form;
        formLoader.after(this.form);
        formLoader.remove();
        this.prepareForm();
    }

    prepareForm() {
        this.submitButton = this.form.querySelector('.js-goto-form-submit');
        this.messageText = this.form.querySelector('.js-goto-form-result');
        this.spinner = this.form.querySelector('.js-goto-form-spinner');
        this.short = this.form.classList.contains('--short');
        this.formActions();
    }

    formData() {
        let data = [];
        this.form.querySelectorAll('input, select, textarea').forEach((element) => {
            let value = element.value;
            if (element.type == 'checkbox' && element.checked != true) {
                value = 0;
            }
            if (element.type != 'radio' || element.checked == true) {
                data[element.getAttribute('name')] = value;
            }
        });

        data['utms'] = this.getUtm();

        return data;
    }

    validateForm(mark = false) {
        let result = true;
        let errorElement = false;
        this.form.querySelectorAll('input:required, select:required, textarea:required').forEach((element) => {
            let validation = this.validate(element, mark);
            if (!validation) {
                result = false;
                if (!errorElement) {
                    errorElement = element;
                }
            }
        });

        if (mark && !result && errorElement) {
            errorElement.scrollIntoView({block: 'center'});
        }

        return result;
    }

    validate(element, mark) {
        let result = true;
        if (!this.validateInputLength(element)) {
            result = false;
        } else {
            if (element.getAttribute('type') == 'radio') {
                result = this.validateRadio(element);
            } else if (element.getAttribute('type') == 'email') {
                result = this.validateEmail(element);
            } else if (element.getAttribute('type') == 'tel') {
                result = this.validatePhone(element);
            }
        }

        if (mark) {
            this.toggleErrorNotice(result, element.name);
        }

        return result;
    }

    validateRadio(input) {
        let name = input.name;
        let result = true;
        if (input.required && !document.querySelector('input[name="' + name + '"]:checked')) {
            result = false;
        }

        return result;
    }

    validateInputLength(input) {
        let result = true;
        if ((!input.value || (input.type == 'checkbox' && input.checked != true)) && !input.hasAttribute('disabled')) {
            result = false;
        }

        return result;
    }

    validateEmail(input) {
        let inputValue = input.value;
        let result = true;
        let pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!pattern.test(inputValue)) {
            result = false;
        }

        return result;
    }

    validatePhone(input) {
        let phone = input.value;
        let result = false;
        if (phone.match(/\d/g)) {
            result = phone.match(/\d/g).length === 11;
        }

        return result;
    }

    toggleErrorNotice(result, name) {
        let errorField = this.form.querySelector('[data-for="' + name + '"]');
        if (errorField) {
            if (!result) {
                errorField.classList.add('noright');
                result = false;
            } else {
                errorField.classList.remove('noright');
            }
        }
    }

    checkFormIsReady() {
        if (this.validateForm()) {
            this.submitButton.classList.remove('disabled');
        } else {
            this.submitButton.classList.add('disabled');
        }
    }

    formActions() {
        this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.sendRequest();
        });

        this.addListeners();
        this.getUtm();
    }

    getUtm() {
        if (new URLSearchParams(this.utms).toString() !== '') {
            return new URLSearchParams(this.utms).toString();
        }

        let eventInput = this.form.querySelector('input[name="event"]');
        if (!eventInput) {
            return new URLSearchParams(this.utms).toString();
        }

        let eventName = eventInput.value.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
        let cookieName = 'meetup_meta_' + eventName;

        let cookie = Cookies.get(cookieName);
        if (cookie) {
            return cookie;
        }

        let isUtms = 0;
        let queryString = window.location.search;
        let searchParams = new URLSearchParams(queryString);
        searchParams.forEach((value, key) => {
            if (key.indexOf('utm') === 0) {
                this.utms[key] = value;
                isUtms = 1;
            }
        });

        if (isUtms) {
            Cookies.set(cookieName, new URLSearchParams(this.utms).toString(), {expires: 30});
        }

        return new URLSearchParams(this.utms).toString();
    }

    sendRequest() {
        if (!this.validateForm(true)) {
            return;
        } else {
            this.spinner.style.display = 'block';
            this.submitButton.disabled = true;
            this.submitButton.classList.add('disabled');
            let data = this.formData();
            data.template = this.settings.template;

            let encodedData = this.encodeParams(data);

            fetch(this.settings.sendRestUrl, {
                method: 'POST', headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                }, body: encodedData
            })
                .then(res => res.json())
                .then(response => {
                    try {
                        if (response?.data?.fields) {
                            response.data.fields.forEach((el) => {
                                this.form.querySelector('[data-for="' + el.name + '"]').textContent = el.message;
                            })
                        }

                        if (!response?.data?.fields) {
                            let height = this.form.offsetHeight;
                            if (window.innerWidth > 1200) {
                                if (height > window.innerHeight) {
                                    height = window.innerHeight;
                                }
                            } else {
                                height = 400;
                            }

                            if (response.status == 200) {
                                if (!this.short) {
                                    this.form.style.minHeight = height + 'px';
                                    this.messageText.innerHTML = this.settings.successMessage;
                                    let text = this.form.querySelector('.js-goto-form-result-message');
                                    if (text && response?.message) {
                                        text.innerHTML = response.message;
                                        if (this.offline) {
                                            let logos = this.form.querySelector('.js-goto-form-online-logos');
                                            if (logos) {
                                                logos.style.display = 'none';
                                            }
                                        }
                                    }
                                } else {
                                    // TODO Add modal separate to body to change how it appears
                                    this.messageText.innerHTML = this.settings.shortSuccessMessage;
                                }

                            } else {
                                this.messageText.innerHTML = this.settings.errorMessage;
                            }
                        }
                    } catch (e) {
                        this.messageText.innerHTML = this.settings.errorMessage;
                        // Обновление каптчи
                        // if (typeof sgr_3 === 'function') {
                        // 	sgr_3();
                        // }
                    }
                })
                .catch(error => {
                    this.messageText.innerHTML = this.settings.errorMessage;
                })
                .then(() => {
                    this.form.classList.add('done');
                    this.submitButton.disabled = false;
                    this.spinner.style.display = 'none';
                    this.close = this.form.querySelectorAll('.js-goto-form-close');
                    if (this.close) {
                        this.close.forEach(button => {
                            button.addEventListener('click', () => {
                                this.form.classList.remove('done');
                                this.messageText.innerHTML = '';
                                this.clearForm();
                            });
                        })
                    }
                });
        }
    }

    /**
     * Makes a string of parameters to send in request to a server.
     * @param {Object} params
     * @returns {string}
     */
    encodeParams(params) {

        return Object.entries(params).map(param => param.map(encodeURIComponent).join("=")).join("&");
    }

    addListeners() {
        this.form.querySelectorAll('.js-goto-form__input, .js-goto-form__checkbox').forEach(element => {
            element.addEventListener('change', (event) => {
                let result = this.validate(event.target);
                this.toggleErrorNotice(result, event.target.name);
                this.checkFormIsReady();
            });
        });

        this.switchView();
        this.form.querySelectorAll('.js-goto-form__radio[name="participation"]').forEach(element => {
            element.addEventListener('change', (event) => {
                this.switchView();
            });
        })

        document.querySelectorAll('.js-reg-online').forEach( link => {
           link.addEventListener('click', () => {
               let target = this.form.querySelector('.js-reg-online-target');
               if ( target ) target.click();

           })
        });

        document.querySelectorAll('.js-reg-offline').forEach( link => {
            link.addEventListener('click', () => {
                let target = this.form.querySelector('.js-reg-offline-target');
                if ( target ) target.click();

            })
        });
    }

    switchView() {
        let offlineBlock = this.form.querySelector('.js-goto-form__offline');
        if (!offlineBlock) {
            return;
        }

        let offlineInput = this.form.querySelector('[name="participation"]:checked');
        if (offlineInput && offlineInput.value == 'offline') {
            offlineBlock.style.display = '';
            this.offline = 1;
        } else {
            offlineBlock.style.display = 'none';
            this.offline = 0;
        }
    }

    clearForm() {
        let newForm = this.formTemplate.cloneNode(true);
        this.form.after(newForm);
        this.form.remove();
        this.form = newForm;
        this.prepareForm();
    }
}

export default ApplicationForm;
